import React, { createContext, useContext } from 'react';
import useColorMode, { ColorMode } from '../theme/useColorMode';

interface ColorModeContextType {
  colorMode: ColorMode;
  setColorMode: (m: ColorMode) => void;
}

export const ColorModeContext = createContext<ColorModeContextType>({
  colorMode: 'light',
  setColorMode: () => {},
});

export const ColorModeProvider = ({ children }: { children: React.ReactNode }) => {
  const [colorMode, setColorMode] = useColorMode();
  return (
    <ColorModeContext.Provider value={{ colorMode, setColorMode }}>
      {children}
    </ColorModeContext.Provider>
  );
};

export const useColorModeContext = () => useContext(ColorModeContext);
